
const API =
    import.meta.env.VITE_SERVICE_API ??
    'https://shopify-api.nowutalk.ai'

const DEMO_STORES = (import.meta.env.VITE_DEMO_STORES ?? '')
    .split(',')
    .map((store: string) => store.trim().toLowerCase())
    .filter(Boolean)

const SERVICE_STATUS_TIMEOUT_MS = 5_000

export const getServiceStatus = async (domain: string) => {
    const url = new URL('/api/v1/agent/check-limit-exceeded', API)
    url.searchParams.set('store_url', domain)

    const normalizedDomain = domain.trim().toLowerCase()
    const isApprovedDemoStore = DEMO_STORES.includes(normalizedDomain)

    // Approved demo stores must remain usable even when the subscription API is
    // unavailable or contains stale billing state. Production stores still use
    // the authoritative API response below.
    if (isApprovedDemoStore) {
        return true
    }

    const controller = new AbortController()
    const timeout = window.setTimeout(
        () => controller.abort(),
        SERVICE_STATUS_TIMEOUT_MS,
    )

    try {
        const response = await fetch(url, { signal: controller.signal })
        if(!response.ok) {
            return false
        }

        const data = await response.json()
        if(data.exceeded) {
            return false
        }

        return true
    } catch {
        return false
    } finally {
        window.clearTimeout(timeout)
    }
}
